import { Injectable } from "@angular/core";
import { DatePipe } from "@angular/common";
import { Scrivania, User } from "../core/core.component";
import { Http, Headers } from "@angular/http";
import { AppConstants } from "../core/app.constants";
import { environment } from "environments/environment";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { Subject } from "rxjs/Subject";

@Injectable()
export class DeskManagementService {
  private manageDeskComponentStatus = new Subject<{user: User, desks: Scrivania[]}>();
  private deskOperation : Subject<any> = new Subject();

  constructor(private http: Http, private datePipe: DatePipe) {}

  getDeskManagementOperationObserver(): Observable<void> {
    return this.deskOperation.asObservable();
  }

  notifyDeskManagementOperationDone() {
    this.deskOperation.next();
  }

  getManageDeskComponentStatus(): Observable<{user: User, desks: Scrivania[]}> {
    return this.manageDeskComponentStatus.asObservable();
  }

  openManageDeskComponent(user: User, userDesk: Scrivania[]) {
    this.manageDeskComponentStatus.next({user: user, desks: userDesk});
  }

  closeManageDeskComponent() {
    this.manageDeskComponentStatus.next();
  }

  getDesks(srmToken: string) {
    var url = environment.REST_SERVICE_BASE_URL + "/ufficio/scrivanie";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http
      .get(url, { headers: headers })
      .map((responseData) => responseData.json());
  }

  getUserDesk(srmToken: string, userId: number) {
    var url =
      environment.REST_SERVICE_BASE_URL + "/ufficio/scrivaniaUtente/" + userId;
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http
      .get(url, { headers: headers })
      .map((responseData) => responseData.json());
  }

  assignDesk(
    srmToken: string,
    selectedDesk: number,
    userId: number,
    deskName: String
  ) {
    var url = environment.REST_SERVICE_BASE_URL + "/ufficio/assegnaScrivania";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    headers.append("Content-Type", "application/json; charset=UTF-8");
    let body = {
      desk: selectedDesk,
      userId: userId,
      deskName: deskName,
    };
    return this.http
      .post(url, body, { headers: headers })
      .map((responseData) => {
        this.notifyDeskManagementOperationDone();
        return responseData.json()
      });
  }

  removeDesk(srmToken: string, selectedDesk: number, userId: number) {
    var url =
      environment.REST_SERVICE_BASE_URL + "/ufficio/disassegnaScrivania";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    headers.append("Content-Type", "application/json; charset=UTF-8");
    let body = {
      desk: selectedDesk,
      userId: userId,
    };
    return this.http
      .post(url, body, { headers: headers })
      .map((responseData) => {
        this.notifyDeskManagementOperationDone();
        return responseData.json()
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/manageDesk.service.ts